import { render } from "./Sondaggi.vue?vue&type=template&id=4b1ef2c0&scoped=true&ts=true"
import script from "./Sondaggi.vue?vue&type=script&lang=ts"
export * from "./Sondaggi.vue?vue&type=script&lang=ts"

import "./Sondaggi.vue?vue&type=style&index=0&id=4b1ef2c0&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_perla_1768301730385742645/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1ef2c0"]])

export default __exports__